// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1wAA0","title":"Header_title__1H0dU","left":"Header_left__2QI4H","clinicName":"Header_clinicName__UmiBw"};